import axios from "axios";
import { serverApi } from "../../../config/Keys";
import {
  SET_LOADER_SECONDARY,
  CLEAR_LOADER,
  CLEAR_ERRORS,
  GET_REPORT_RESTAURANT,
  GET_REPORT_BY_SERVICE,
  GET_REPORT_BY_TYPE,
  GET_SETTLEMENT_REPORT,
  GET_SETTLEMENT_TYPE_REPORT,
  GET_ORDER_ITEM_TAX,
  GET_PAYMENT_ORDER,
  GET_PAYMENT_SCAN,
  GET_PAYMENT_EVENT,
  GET_INVOICE,
  GET_EVENT,
  GET_ALL_ORDER,
  GET_OFFER_VENDOR,
  GET_ITEM_REPORT_VENDOR,
  GET_SCAN_AND_PAY_REPORT_VENDOR,
  GET_ALL_SEATING_VENDOR,
  GET_SEATING_PENDING_VENDOR,
} from "../../types";
import { setErrors } from "../errorActions";

export const dinerLiveReport =
  (queryParams, token, type) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    //   dispatch({ type: SET_LOADER });
    //   console.log(currentdate, to, from);
    try {
      let get_restaurant_reports = await axios.get(
        `${serverApi}/dinerReports?${queryParams}`,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      // console.log(get_restaurant_reports);
      if (get_restaurant_reports.status === 200) {
        if (type === 0) {
          dispatch({
            type: GET_REPORT_RESTAURANT,
            payload: get_restaurant_reports.data,
          });
        } else if (type === 1) {
          dispatch({
            type: GET_REPORT_BY_SERVICE,
            payload: get_restaurant_reports.data,
          });
        } else if (type === 2) {
          dispatch({
            type: GET_REPORT_BY_TYPE,
            payload: get_restaurant_reports.data,
          });
        }

        //   onSuccess();
        //   dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
      // onError();
    }
  };

export const settlementSummary = (token, dateQuery, settle_payment_status) => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });

  try {
    let get_settlement_report = [];
    // if(dateQuery.startDate !== undefined){
    get_settlement_report = await axios.get(
      `${serverApi}/report/settlement?type=SUMMARY&settle_payment_status=${settle_payment_status}&startDate=${dateQuery.startDate}&endDate=${dateQuery.endDate}`,
      {
        headers: {
          Authorization: token,
        },
      }
    );
    // }
    // else{
    //   get_settlement_report = await axios.get(
    //     `${serverApi}/report/settlement?type=SUMMARY`,
    //     {
    //       headers: {
    //         Authorization: token,
    //       },
    //     }
    //   );
    // }

    if (get_settlement_report.status === 200) {
      dispatch({
        type: GET_SETTLEMENT_REPORT,
        payload: get_settlement_report.data,
      });
    }
  } catch (err) {
    dispatch({ type: CLEAR_LOADER });
    dispatch(setErrors(err));
  }
};

export const settlementReport = (id, token, type) => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
  dispatch({ type: SET_LOADER_SECONDARY });
  try {
    let get_settlement_type_report = await axios.get(
      `${serverApi}/report/settlement/${id}?type=${type}`,
      {
        headers: {
          Authorization: token,
        },
      }
    );

    if (get_settlement_type_report.status === 200) {
      dispatch({
        type: GET_SETTLEMENT_TYPE_REPORT,
        payload: get_settlement_type_report.data,
      });
      dispatch({ type: CLEAR_LOADER });
      console.log("report", get_settlement_type_report);
    }
  } catch (err) {
    dispatch({ type: CLEAR_LOADER });
    dispatch(setErrors(err));
  }
};

export const OrderItemTaxReport =
  (token, type, startDate, endDate) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER_SECONDARY });
    try {
      let get_order_item_tax = [];
      // if(dateQuery.startDate !== undefined){
      get_order_item_tax = await axios.get(
        `${serverApi}/vendor/order-reports?reportType=${type}&startDate=${startDate}&endDate=${endDate}`,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      // }else{
      //   get_order_item_tax = await axios.get(
      //     `${serverApi}/vendor/order-reports?reportType=${type}`,
      //     {
      //       headers: {
      //         Authorization: token,
      //       },
      //     }
      //   );
      // }

      if (get_order_item_tax.status === 200) {
        dispatch({
          type: GET_ORDER_ITEM_TAX,
          payload: get_order_item_tax.data,
        });
        dispatch({ type: CLEAR_LOADER });
        console.log("tax", get_order_item_tax);
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const PaymentActivityOrderReport = (token, type, startDate, endDate) => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
  dispatch({ type: SET_LOADER_SECONDARY });
  try {
    let get_payment_order = await axios.get(
      `${serverApi}/vendor/transactional?type=${type}&startDate=${startDate}&endDate=${endDate}`,
      {
        headers: {
          Authorization: token,
        },
      }
    );

    if (get_payment_order.status === 200) {
      dispatch({
        type: GET_PAYMENT_ORDER,
        payload: get_payment_order.data,
      });
      dispatch({ type: CLEAR_LOADER });
      // console.log("order",get_payment_order);
    }
  } catch (err) {
    dispatch({ type: CLEAR_LOADER });
    dispatch(setErrors(err));
  }
};

export const PaymentActivityAdminReportVendor =
  (token, merchant_id, type) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER_SECONDARY });
    try {
      let get_payment_order = await axios.get(
        `${serverApi}/admin/transactional?vendorId=${merchant_id}&type=${type}`,
        {
          headers: {
            Authorization: token,
          },
        }
      );

      if (get_payment_order.status === 200) {
        dispatch({
          type:
            type === "0"
              ? GET_PAYMENT_ORDER
              : type === "1"
              ? GET_PAYMENT_EVENT
              : type === "2"
              ? GET_PAYMENT_SCAN
              : "",
          payload: get_payment_order.data,
        });
        dispatch({ type: CLEAR_LOADER });
        // console.log("order",get_payment_order);
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const PaymentActivityEventReport = (token, type, startDate, endDate) => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
  dispatch({ type: SET_LOADER_SECONDARY });
  try {
    let get_payment_event = await axios.get(
      `${serverApi}/vendor/transactional?type=${type}&startDate=${startDate}&endDate=${endDate}`,
      {
        headers: {
          Authorization: token,
        },
      }
    );

    if (get_payment_event.status === 200) {
      dispatch({
        type: GET_PAYMENT_EVENT,
        payload: get_payment_event.data,
      });
      dispatch({ type: CLEAR_LOADER });
      // console.log("event",get_payment_event);
    }
  } catch (err) {
    dispatch({ type: CLEAR_LOADER });
    dispatch(setErrors(err));
  }
};

export const PaymentActivityScanReport = (token, type, startDate, endDate) => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
  dispatch({ type: SET_LOADER_SECONDARY });
  try {
    let get_payment_scan = await axios.get(
      `${serverApi}/vendor/transactional?type=${type}&startDate=${startDate}&endDate=${endDate}`,
      {
        headers: {
          Authorization: token,
        },
      }
    );
    console.log("scan", get_payment_scan);

    if (get_payment_scan.status === 200) {
      dispatch({
        type: GET_PAYMENT_SCAN,
        payload: get_payment_scan.data,
      });
      dispatch({ type: CLEAR_LOADER });
    }
  } catch (err) {
    dispatch({ type: CLEAR_LOADER });
    dispatch(setErrors(err));
  }
};

export const Invoice_Reports = (token, dateQuery) => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
  dispatch({ type: SET_LOADER_SECONDARY });
  console.log(dateQuery);
  try {
    let get_invoice = [];
    get_invoice = await axios.get(
      `${serverApi}/admin/transactionalReport?startDate=${dateQuery.startDate}&endDate=${dateQuery.endDate}`,
      {
        headers: {
          Authorization: token,
        },
      }
    );
    if (get_invoice.status === 200) {
      dispatch({
        type: GET_INVOICE,
        payload: get_invoice.data,
      });
      dispatch({ type: CLEAR_LOADER });
      console.log("invoice", get_invoice);
    }
  } catch (err) {
    dispatch({ type: CLEAR_LOADER });
    dispatch(setErrors(err));
  }
};

export const Event_Reports = (token, dateQuery) => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
  dispatch({ type: SET_LOADER_SECONDARY });
  // console.log(dateQuery);
  try {
    let get_event = [];
    get_event = await axios.get(
      `${serverApi}/vendor/events?startDate=${dateQuery.startDate}&endDate=${dateQuery.endDate}`,
      // `${serverApi}/vendor/events`,
      {
        headers: {
          Authorization: token,
        },
      }
    );
    if (get_event.status === 200) {
      dispatch({
        type: GET_EVENT,
        payload: get_event.data,
      });
      dispatch({ type: CLEAR_LOADER });
      console.log("get_event", get_event);
    }
  } catch (err) {
    dispatch({ type: CLEAR_LOADER });
    dispatch(setErrors(err));
  }
};

export const All_Order_Reports = (token, dateQuery) => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
  dispatch({ type: SET_LOADER_SECONDARY });
  // console.log(dateQuery);
  try {
    let get_order = [];
    get_order = await axios.get(
      `${serverApi}/vendor/order-reports?reportType=allOrder&startDate=${dateQuery.startDate}&endDate=${dateQuery.endDate}`,
      // `${serverApi}/vendor/order-reports?reportType=allOrder`,
      {
        headers: {
          Authorization: token,
        },
      }
    );
    if (get_order.status === 200) {
      dispatch({
        type: GET_ALL_ORDER,
        payload: get_order.data,
      });
      dispatch({ type: CLEAR_LOADER });
      console.log("get_order", get_order);
    }
  } catch (err) {
    dispatch({ type: CLEAR_LOADER });
    dispatch(setErrors(err));
  }
};

export const offer_vendor_reports = (token, dateQuery) => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
  dispatch({ type: SET_LOADER_SECONDARY });
  // console.log(dateQuery);
  try {
    let get_offer = [];
    get_offer = await axios.get(
      `${serverApi}/vendor/offers?startDate=${dateQuery.startDate}&endDate=${dateQuery.endDate}`,
      // `${serverApi}/vendor/offers`,
      {
        headers: {
          Authorization: token,
        },
      }
    );
    if (get_offer.status === 200) {
      dispatch({
        type: GET_OFFER_VENDOR,
        payload: get_offer.data,
      });
      dispatch({ type: CLEAR_LOADER });
      console.log("get_offer", get_offer);
    }
  } catch (err) {
    dispatch({ type: CLEAR_LOADER });
    dispatch(setErrors(err));
  }
};

export const item_reports =
  (token, vendorId, dateQuery) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER_SECONDARY });
    // console.log(dateQuery);
    try {
      let get_item_reports_vendor = [];
      get_item_reports_vendor = await axios.get(
        `${serverApi}/vendor/item-report/${vendorId}?startDate=${dateQuery.startDate}&endDate=${dateQuery.endDate}`,
        // `${serverApi}/vendor/item-report/${vendorId}`,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (get_item_reports_vendor.status === 200) {
        dispatch({
          type: GET_ITEM_REPORT_VENDOR,
          payload: get_item_reports_vendor.data,
        });
        dispatch({ type: CLEAR_LOADER });
        console.log("get_item_reports_vendor", get_item_reports_vendor);
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const vendor_scan_and_pay_reports =
  (token, dateQuery) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER_SECONDARY });
    // console.log(dateQuery);
    try {
      let get_scan_report = [];
      get_scan_report = await axios.get(
        `${serverApi}/vendor/transactional?type=1&startDate=${dateQuery.startDate}&endDate=${dateQuery.endDate}`,
        // `${serverApi}/vendor/transactional?type=1`,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (get_scan_report.status === 200) {
        dispatch({
          type: GET_SCAN_AND_PAY_REPORT_VENDOR,
          payload: get_scan_report.data,
        });
        dispatch({ type: CLEAR_LOADER });
        console.log("get_scan_report", get_scan_report);
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const vendor_all_seating_report =
  (token, dateQuery) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER_SECONDARY });
    // console.log(dateQuery);
    try {
      let get_all_seating_report = [];
      get_all_seating_report = await axios.get(
        `${serverApi}/vendor/diner-report?startDate=${dateQuery.startDate}&endDate=${dateQuery.endDate}`,
        // `${serverApi}/vendor/diner-report`,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (get_all_seating_report.status === 200) {
        dispatch({
          type: GET_ALL_SEATING_VENDOR,
          payload: get_all_seating_report.data,
        });
        dispatch({ type: CLEAR_LOADER });
        console.log("get_all_seating_report", get_all_seating_report);
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const vendor_seating_pending_report =
  (token, dateQuery) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER_SECONDARY });
    // console.log(dateQuery);
    try {
      let get_seating_pending_report = [];
      get_seating_pending_report = await axios.get(
        `${serverApi}/vendor/diner-report?diner_status=PENDING&startDate=${dateQuery.startDate}&endDate=${dateQuery.endDate}`,
        // `${serverApi}/vendor/diner-report?diner_status=PENDING`,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (get_seating_pending_report.status === 200) {
        dispatch({
          type: GET_SEATING_PENDING_VENDOR,
          payload: get_seating_pending_report.data,
        });
        dispatch({ type: CLEAR_LOADER });
        console.log("get_seating_pending_report", get_seating_pending_report);
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };
